export const enum planConstants {
  listPlanRequest = "LIST_PLAN_REQUEST",
  listPlansSuccess = "LIST_PLAN_SUCCESS",
  listPlanFailure = "LIST_PLAN_FAILURE",

  createPlanRequest = "CREATE_PLAN_REQUEST",
  createPlanSuccess = "CREATE_PLAN_SUCCESS",
  createPlanFailure = "CREATE_PLAN_FAILURE",

  viewPlanRequest = "VIEW_PLAN_REQUEST",
  viewPlanSuccess = "VIEW_PLAN_SUCCESS",
  viewPlanFailure = "VIEW_PLAN_FAILURE",

  updatePlanRequest = "UPDATE_PLAN_REQUEST",
  updatePlanSuccess = "UPDATE_PLAN_SUCCESS",
  updatePlanFailure = "UPDATE_PLAN_FAILURE",

}
